// extracted by mini-css-extract-plugin
export default {"badge":"Resultado_badge__o5ych"};